// ============================================
// 💻 COMPÉTENCES
// Liste des technologies avec lesquelles tu as travaillé
// ============================================

export const skillCategories = [
  {
    title: "Backend",
    icon: "⚙️",
    skills: ["PHP", "Laravel", "API REST", "SQL", "MySQL"]
  },
  {
    title: "Frontend",
    icon: "🎨",
    skills: ["JavaScript", "React", "Vue.js", "HTML5", "CSS3", "Tailwind"]
  },
  {
    title: "Mobile",
    icon: "📱",
    skills: ["Flutter", "Dart", "Responsive Design"]
  },
  {
    title: "Outils & DevOps",
    icon: "🔧",
    skills: ["Git", "GitHub", "Docker", "Docker Compose", "Linux"]
  },
  {
    title: "CMS & Autres",
    icon: "🌐",
    skills: ["Joomla", "WordPress", "UX/UI", "SEO", "Figma"]
  }
];

// ============================================
// 🏷️ LANGAGES DE PROGRAMMATION
// Liste affichée en tags sur la page compétences
// ============================================

export const programmingLanguages = [
  "PHP",
  "JavaScript", 
  "Python",
  "Java",
  "SQL",
  "Dart",
  "HTML",
  "CSS"
];